import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function (location) {
  return originalPush.call(this, location).catch(() => {})
}

const routes = [
  { path: '/login', component: () => import('@/views/Login.vue') },
  {
    path: '/',
    component: () => import('@/views/Layout.vue'),
    redirect: '/stats',
    children: [
      { path: 'stats',    component: () => import('@/views/stats/Index.vue') },
      { path: 'member',   component: () => import('@/views/member/Index.vue') },
      { path: 'activity', component: () => import('@/views/activity/Index.vue') },
      { path: 'admin',    component: () => import('@/views/admin/Index.vue') }
    ]
  },
  { path: '*', redirect: '/stats' }
]

const router = new VueRouter({ mode: 'history', routes })

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.path !== '/login' && !token) {
    next('/login')
  } else if (to.path === '/login' && token) {
    next('/stats')
  } else {
    next()
  }
})

export default router
